export const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
export const week = { 'Sun': 0, 'Mon': 1, 'Tue': 2, 'Wed': 3, 'Thu': 4, 'Fri': 5, 'Sat': 6 }
export const weekMap = ['日', '一', '二', '三', '四', '五', '六']
/**
 * @description 构建指定长度数组
 * @param {number} length
 * @returns {undefined[]}
 */
export const makeArr = (length) => Array.from({ length });
export const getMonthEndDay = (y, m) => new Date(y, m, 0).getDate();
export function getToday() {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return today;
}

export function isToday(date,today = getToday()) {
  if (!(date instanceof Date)) {
    date = new Date(date)
  }
  date.setHours(0, 0, 0, 0)
  if (!(today instanceof Date)) {
    today = new Date(today)
  }
  today.setHours(0, 0, 0, 0)
  return today.getTime() === date.getTime()
}

export function isTomorrow(date, today = getToday()) {
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  date.setHours(0, 0, 0, 0);
  if (!(today instanceof Date)) {
    today = new Date(today)
  }
  const tomorrow = today;
  tomorrow.setDate(tomorrow.getDate() + 1);
  tomorrow.setHours(0, 0, 0, 0);
  return tomorrow.getTime() === date.getTime();
}

export function isLastDay(date, today = getToday()) {
  if (!(date instanceof Date)) {
    date = new Date(date);
  }
  date.setHours(0, 0, 0, 0);
  if (!(today instanceof Date)) {
    today = new Date(today)
  }
  const yesterday = today;
  yesterday.setDate(yesterday.getDate() - 1);
  yesterday.setHours(0, 0, 0, 0);
  return yesterday.getTime() === date.getTime();
}

export function someTomorrow(current = [], dawn = false, today = Date.now()) {
  current = Array.isArray(current) ? current : [current]
  return current.some(
    (date) => (dawn ? isLastDay(date, today) : isTomorrow(date, today)) || isToday(date, today)
  )
}
/**
 *
 * @description 比较两个时间
 * @export
 * @param {*} date1
 * @param {*} date2
 * @return {*}
 *  0 - 相等
 *  1 - date1 > date2
 *  -1 date1 < date2
 */
export function compare(date1, date2) {
  if (!(date1 instanceof Date)) {
    date1 = new Date(date1);
  }
  if (!(date2 instanceof Date)) {
    date2 = new Date(date2);
  }
  date1.setHours(0, 0, 0, 0);
  date2.setHours(0, 0, 0, 0);
  if (date1.getTime() === date2.getTime()) {
    return 0;
  } else if (date1 > date2) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * @description: 转Date对象
 * @param {*} date 字符串或数字
 * @return {Date} Date实例 
 */
export const parseDate = (date) => {
  if (typeof date == 'string' || typeof date == 'number') {
    if (typeof date === 'string') {
      // ios 中 '2018-04-27 11:11' 格式的字符串不能 new Date(), 需要将 '-' 替换为 '/'
      date = date.replace(/-/g, '/')
    }
    date = new Date(date)
  }
  if (date === 'Invalid Date') {
    throw new Error('Invalid Date 日期格式不正确')
  }
  return date
}

/**
 *
 * @description 获取偏移后的日期
 * @export
 * @param {*} date
 * @param {*} offset
 * @return {*} 
 *  date 结果时间
 */
export function getDayByOffset(date, offset) {
  date = date instanceof Date ? date : parseDate(date);
  date.setDate(date.getDate() + offset);
  return date;
}

export function getPrevDay(date) {
  return getDayByOffset(date, -1);
}

export function getNextDay(date) {
  return getDayByOffset(date, 1);
}

export function calcDateNum(date1, date2) {
  const day1 = new Date(date1).getTime();
  const day2 = new Date(date2).getTime();
  return (day2 - day1) / (1000 * 60 * 60 * 24) + 1;
}


/**
* @description 用于时间取值
* @param  {...any} args
*/
export function getFullDate(date) {
  if (!date) date = new Date()
  if (!(date instanceof Date)) date = new Date(date)
  const _d = date.toString().split(' ')
  const _m = _d[4].match(/(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?/) || []

  return {
    year: +_d[3],
    month: +month.indexOf(_d[1]) + 1,
    day: +_d[2],
    hour: +_m[1],
    minute: +_m[2],
    second: +_m[3],
    week: +week[_d[0]],
    weekName: weekMap[+week[_d[0]]]
  }
}

/**
 * @description: 时间格式化方法
 * @param {*} date 需要格式化的时间，默认为当前时间
 * @param {*} fmt YYYY-MM-dd hh:mm:ss
 * @return {string} 格式化后的字符串时间
 */
export function formatDate(date = new Date(), fmt = 'YYYY-MM-dd') {
  if (typeof date == 'string' || typeof date == 'number') {
    if (typeof date === 'string') {
      // ios 中 '2018-04-27 11:11' 格式的字符串不能 new Date(), 需要将 '-' 替换为 '/'
      date = date.replace(/-/g, '/')
    }
    date = new Date(date)
  }
  if (date == 'Invalid Date') {
    return ''
  }
  const year = date.getFullYear();
  const month = date.getMonth() + 1; 
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const formatTokens = {
    'YYYY': year,
    'MM': String(month).padStart(2, '0'),
    'dd': String(day).padStart(2, '0'),
    'hh': String(hours).padStart(2, '0'),
    'mm': String(minutes).padStart(2, '0'),
    'ss': String(seconds).padStart(2, '0'),
    'yy': String(year).slice(-2),
  };

  return fmt.replace(/(YYYY|MM|dd|hh|mm|ss|yy)/g, (match) => formatTokens[match] || match);
}